module.exports = __webpack_public_path__ + "img/pt.1294fa38.jpg";